import { render, staticRenderFns } from "./FireStoppingReportSitePlanView.vue?vue&type=template&id=2855aabe&"
import script from "./FireStoppingReportSitePlanView.vue?vue&type=script&lang=js&"
export * from "./FireStoppingReportSitePlanView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports